import {Component, OnInit} from '@angular/core';

import {PlayerService} from '../../core/services/player/player.service';
import {PlayerTimes} from '../../core/services/player/player.model';

@Component({
  selector: 'psr-player-seek',
  templateUrl: './player-seek.component.html',
  styleUrls: ['./player-seek.component.scss']
})
export class PlayerSeekComponent {

  public times: PlayerTimes = null;
  public seeking = false;
  private seekPosition = 0;
  public cursorPosition: number = null;

  constructor(private playerService: PlayerService) {
    this.playerService.times.subscribe((times: PlayerTimes) => {
      this.times = times;
    });
  }

  formatTime(time: number) {
    const seconds = Math.round(time) % 60;
    const minutes = Math.floor(Math.round(time) / 60) % 60;
    const hours = Math.floor(Math.floor(Math.round(time) / 60) / 60) % 60;

    if (isNaN(seconds) || isNaN(minutes)) {
      return '-:--:--';
    }

    let str = '';

    str += hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    return str;
  }

  seekMouseDown($event) {
    this.seekPosition = $event.offsetX;
    this.seeking = true;
  }

  seekMouseMove($event) {
    if (this.seeking) {
      this.seekPosition = $event.offsetX;
      this.cursorPosition = this.seekPosition / $event.target.offsetWidth * 100;
    }
  }

  seekMouseUp($event) {
    if (this.seeking) {
      this.playerService.seekByPercent(this.seekPosition / $event.target.offsetWidth * 100);
      this.seeking = false;
      this.cursorPosition = null;
    }
  }

  seekTouchDown($event) {
    this.seekPosition = $event.touches[0].clientX - 85;
    this.seeking = true;
  }

  seekTouchMove($event) {
    if (this.seeking) {
      this.seekPosition = $event.touches[0].clientX - 85;
      this.cursorPosition = this.seekPosition / $event.target.offsetWidth * 100;
    }
  }

  seekTouchUp($event) {
    if (this.seeking) {
      this.playerService.seekByPercent(this.seekPosition / $event.target.offsetWidth * 100);
      this.seeking = false;
      this.cursorPosition = null;
    }
  }
}
